import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box, Link as MuiLink, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Content from "../componentsPeopletech/Content";
import Gallery from "../componentsPeopletech/Gallery";
import Footer from "../componentsPeopletech/Footer/Footer";

const About = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = 'https://www.peoplefortech.com';

  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>{t('nav.about')} - PeopleForTech</title>
        <meta name="description" content={`${t('nav.about')} - ${t('seo.homeDescription')}`} />
        <link rel="canonical" href={`${baseUrl}/about`} />
        <html lang={currentLang} />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/about`} />
        <meta property="og:title" content={`${t('nav.about')} - PeopleForTech`} />
        <meta property="og:description" content={`${t('nav.about')} - ${t('seo.homeDescription')}`} />
        
        {/* Schema.org JSON-LD para SEO de IA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": `${t('nav.about')} - PeopleForTech`,
            "description": `${t('nav.about')} - ${t('seo.homeDescription')}`,
            "url": `${baseUrl}/about`,
            "mainEntity": {
              "@type": "Organization",
              "name": "PeopleForTech",
              "url": baseUrl,
              "description": t('seo.homeDescription')
            },
            "inLanguage": currentLang
          })}
        </script>
      </Helmet>
      <Content />
      <Gallery />
      <Box sx={{ textAlign: "center", px: 2, mb: 3 }}>
        <Typography variant="body1" sx={{ color: "#111", mb: 1 }}>
          También ayudamos a empresas a mejorar su visibilidad en asistentes de IA.
        </Typography>
        <MuiLink
          component={RouterLink}
          to="/geo-para-chatgpt-gemini"
          underline="hover"
          sx={{ fontWeight: 700, color: "#1e2a5a" }}
        >
          Ver estrategia GEO para ChatGPT y Gemini
        </MuiLink>
      </Box>
      <Footer />
    </>
  );
};

export default About;
